<template>
  <div>
    <div class="container">

      <div class="columns mt-01">

        <div class="column">
          <iframe class="frame-pdf" src="https://croccancun.com/assets/pdf/Organigrama_CROC_V2.pdf" style="border:none;overflow:hidden" scrolling="no" frameborder="0" allowTransparency="true" allowFullScreen="true"></iframe>

        </div>


      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'Conocenos',
  data () {
    return {

    }
  },
  computed: {
  },
  components: {

  },
  mounted() {

  },
  methods:{

  },
  created :function(){
  }
}
</script>

<style scoped>
frame-pdf{
  width: 100%;
  height: 600px;
}
</style>



// WEBPACK FOOTER //
// src/components/Conocenos.vue